import React, { FC } from 'react';
import Responsive, { MediaQueryProps, useMediaQuery } from 'react-responsive';


const width = {
    desktop: 1200,
    mobile: 767,
};

type ResponsiveProps = {
    children: MediaQueryProps['children'];
};

export const Desktop: FC<ResponsiveProps> = ({ children }) => (
    <Responsive minWidth={width.desktop}>
        {children}
    </Responsive>
);

export const Tablet: FC<ResponsiveProps> = ({ children }) => (
    <Responsive minWidth={width.mobile + 1} maxWidth={width.desktop - 1}>
        {children}
    </Responsive>
);

export const Mobile: FC<ResponsiveProps> = ({ children }) => (
    <Responsive maxWidth={width.mobile}>
        {children}
    </Responsive>
);

export const useMobile = () => useMediaQuery({ maxWidth: width.mobile });

export const useTablet = () => useMediaQuery(
    { minWidth: width.mobile + 1, maxWidth: width.desktop - 1 },
);

export const useDesktop = () => useMediaQuery({ minWidth: width.desktop });

export const useMediaSwitch = <TArg1 extends any, TArg2 extends any, TArg3 extends any>(
    desktop: TArg1,
    tablet: TArg2,
    mobile: TArg3,
): TArg1 | TArg2 | TArg3 => {
    const isMobile = useMobile();
    const isTablet = useTablet();
    return isMobile
        ? mobile : isTablet
            ? tablet : desktop;
};

